import styled from 'styled-components';

import colors from '../../../../../../../styles/colors';

export const Container = styled.div`
  width: 100%;
  min-height: 104px;
  margin-top: 22px;
  padding: 16px;

  background: ${colors.$calendula_gold_1};
  border: 1px solid ${colors.$calendula_gold_3};

  p {
    margin: 0;
    line-height: 18px;
  }
`;

export const InfoHeader = styled.div`
  margin-bottom: 16px;

  svg {
    margin-right: 10px;
    color: ${colors.$auxiliary_yolk_5};
  }
`;
